module.exports = __webpack_public_path__ + "img/photo-user-3.5b7d5ad4.svg";